import { combineEpics } from 'redux-observable'
import { fetchSpinStateEpic, spinFocusRevalidationEpic } from './SpinStatusEpics.ts'
import { fetchSpinMetaEpic } from './SpinMetaEpics.ts'

export const spinEpics = combineEpics(fetchSpinStateEpic, fetchSpinMetaEpic, spinFocusRevalidationEpic)
